import store from "@/store";

const navigationGuards = {
	setupGlobal(router) {
		router.beforeEach((to, from, next) => {
			if (to.query.activeTab) {
				store.dispatch("session/setActiveTab", { tabGroup: to.query.tabGroup || to.path, activeTab: to.query.activeTab });

				delete to.query.activeTab;
				next({path: to.path, query: to.query});
			} else {
				next();
			}
		})
	}
}

export {
	navigationGuards
}
